import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const InsightsIcon = () => (
  <SvgIcon width="32" height="32" viewBox="0 0 32 32">
    {/* Document shape with license badge */}
    <path
      d="M8 5C8 4.45 8.45 4 9 4H18L24 10V27C24 27.55 23.55 28 23 28H9C8.45 28 8 27.55 8 27V5Z"
      fill="#17E88F"
    />
    <path d="M18 4L24 10H19C18.45 10 18 9.55 18 9V4Z" fill="#0FB870" />

    {/* License badge/seal */}
    <circle cx="16" cy="18" r="6" fill="#0D9359" />
    <path
      d="M16 14L17.5 16.5L20 17L18 19L18.5 21.5L16 20.25L13.5 21.5L14 19L12 17L14.5 16.5L16 14Z"
      fill="#17E88F"
    />
  </SvgIcon>
);

export default InsightsIcon;
